import { Record } from "../../fable_modules/fable-library.3.7.12/Types.js";
import { int32_type, class_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.12/Reflection.js";

export class AnatomicalRegionLabelViewModel extends Record {
    constructor(streamPath) {
        super();
        this.streamPath = streamPath;
    }
}

export function AnatomicalRegionLabelViewModel$reflection() {
    return record_type("Optiscan.Models.View.AnatomicalRegion.AnatomicalRegionLabelViewModel", [], AnatomicalRegionLabelViewModel, () => [["streamPath", string_type]]);
}

export class AnatomicalRegionViewModel extends Record {
    constructor(sessionId, frameNumber, streamPath) {
        super();
        this.sessionId = sessionId;
        this.frameNumber = (frameNumber | 0);
        this.streamPath = streamPath;
    }
}

export function AnatomicalRegionViewModel$reflection() {
    return record_type("Optiscan.Models.View.AnatomicalRegion.AnatomicalRegionViewModel", [], AnatomicalRegionViewModel, () => [["sessionId", class_type("System.Guid")], ["frameNumber", int32_type], ["streamPath", string_type]]);
}

